/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h, F as Fragment, r as registerInstance, g as getElement } from './index-C_ZKddLG.js';
import { a as __rest, _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { c as clsx } from './clsx-COFh-Vc8.js';
import { g as getMsgType, i as isMsgDefinedAndInputTouched, c as getDefaultProps, a as getRenderStates, F as FormFieldStateWrapper } from './FormFieldStateWrapper-CANKwnKv.js';
import { I as InputIconController, a as InputContainerStateWrapperFc } from './controller-icon-GPaN1UHM.js';
import { J as watchJsonArrayString } from './common-D-vggmh2.js';
import { c as createUniqueId } from './dev.utils-Cib2ENyx.js';
import { b as directFocus, e as directClick, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import { p as propagateSubmitEventToForm } from './controller-D__mtOju.js';
import { v as validateMultiple } from './multiple-BZRAazRb.js';
import { f as fillKeyOptionMap, v as validateOptionsWithOptgroup } from './controller-CnmYmyZK.js';
import { v as validateRequired } from './required-CGf-IRxL.js';
import { v as validateRows } from './rows-DlWRIMNQ.js';
import './associated.controller-FCQDejnI.js';
import './aria-details-hRfn8aN9.js';
import './aria-labelledby-6-ki3akM.js';
import './bootstrap-Bfno1qh2.js';
import './component-names-DwvrfFak.js';
import './i18n-C73LqPIs.js';
import './disabled-CL52u2mm.js';
import './hide-label-CRGm6KGP.js';
import './label-w3T7Y2ih.js';
import './tooltip-align-BQmLWbBy.js';
import './align-C8fl12z_.js';
import './variant-class-name-9qZ5egaq.js';
import './events-BhfZTW2e.js';
import './access-and-short-key-ijzCZfHm.js';
import './i18n-CvFPh0g5.js';
import './base-web-component-D909Fl-Y.js';
import './behavior-Co00uT-D.js';
import './align-floating-elements-CBhVmYjn.js';
import './tooltip-open-tracking-D3tCiiGP.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './label-FtX-skKy.js';
import './variant-quote-ClYWonZq.js';
import './component-BXCnkVUN.js';
import './component-DepnuZGT.js';
import './bem-registry-3ondDImf.js';
import './component-BjVFpeYY.js';
import './Alert-BjiZcCeA.js';
import './Heading-CNfXfPK2.js';
import './icons-mXXqyviE.js';
import './element-focus-BQXzaLL9.js';
import './orientation-CfF8dz-f.js';

const NativeOptionFc = (_a) => {
    var { baseClassName = 'kol-select', class: classNames, index, selectedValue, selected, value, label, disabled } = _a, other = __rest(_a, ["baseClassName", "class", "index", "selectedValue", "selected", "value", "label", "disabled"]);
    if (selectedValue === undefined) {
        selectedValue = [];
    }
    else if (!Array.isArray(selectedValue)) {
        selectedValue = [selectedValue];
    }
    const isSelected = selected || selectedValue.includes(value);
    return (h("option", Object.assign({ class: clsx(`${baseClassName}__option`, {
            [`${baseClassName}__option--selected`]: isSelected,
            [`${baseClassName}__option--disabled`]: disabled,
        }, classNames), selected: isSelected, disabled: disabled, value: index }, other), label));
};

const NativeOptionListFc = ({ baseClassName, preKey, options, disabled, value: selectedValue, OptionProps = {}, OptionGroupProps = {}, }) => {
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
        return null;
    }
    return (h(Fragment, null, options.map((option, index) => {
        const key = [preKey, `-${index}`].join('');
        if ('options' in option) {
            if (!options.length) {
                return null;
            }
            const { label } = option, other = __rest(option, ["label"]);
            return (h("optgroup", Object.assign({ class: clsx(`${baseClassName}__optgroup`, { [`${baseClassName}__optgroup--disabled`]: disabled }), key: key }, OptionGroupProps, { label: label === null || label === void 0 ? void 0 : label.toString(), disabled: disabled }), h(NativeOptionListFc, Object.assign({ baseClassName: baseClassName, OptionGroupProps: OptionGroupProps, OptionProps: OptionProps, value: selectedValue, preKey: key }, other))));
        }
        if ('value' in option) {
            return h(NativeOptionFc, Object.assign({ key: key, baseClassName: baseClassName }, OptionProps, { index: key, selectedValue: selectedValue }, option));
        }
        return null;
    })));
};

const NativeSelectFc = (props) => {
    const { class: classNames, msg, touched, disabled, required, options, value, OptionProps, OptionGroupProps, ariaDescribedBy, hideLabel, label } = props, other = __rest(props, ["class", "msg", "touched", "disabled", "required", "options", "value", "OptionProps", "OptionGroupProps", "ariaDescribedBy", "hideLabel", "label"]);
    const stateCssClasses = {
        ['kol-select--disabled']: Boolean(disabled),
        ['kol-select--required']: Boolean(required),
        ['kol-select--touched']: Boolean(touched),
        [`kol-select--${getMsgType(msg)}`]: isMsgDefinedAndInputTouched(msg, touched),
    };
    const inputProps = Object.assign(Object.assign({ class: clsx('kol-select', stateCssClasses, classNames), required: required, disabled: disabled }, getDefaultProps({ ariaDescribedBy, hideLabel, label })), other);
    return (h("select", Object.assign({}, inputProps), h(NativeOptionListFc, { baseClassName: "kol-select", options: options, value: value, OptionGroupProps: OptionGroupProps, OptionProps: OptionProps })));
};

function getSelectProps(state) {
    const { ariaDescribedBy, hasError } = getRenderStates(state);
    const props = {
        id: state._id,
        hideLabel: state._hideLabel,
        label: state._label,
        value: state._value,
        options: state._options,
        accessKey: state._accessKey,
        disabled: state._disabled,
        name: state._name,
        'aria-invalid': hasError ? 'true' : undefined,
        ariaDescribedBy: ariaDescribedBy,
        size: state._multiple ? state._rows : undefined,
        multiple: state._multiple,
        required: state._required,
        touched: state._touched,
        msg: state._msg,
    };
    if ('_shortKey' in state)
        props['aria-keyshortcuts'] = state._shortKey;
    return props;
}
const SelectStateWrapper = (_a) => {
    var { state } = _a, other = __rest(_a, ["state"]);
    return h(NativeSelectFc, Object.assign({}, getSelectProps(state), other));
};

class SelectController extends InputIconController {
    constructor(component, name, host) {
        super(component, name, host);
        this.keyOptionMap = new Map();
        this.getOptionByKey = (key) => this.keyOptionMap.get(key);
        this.isValueInOptions = (value, options) => {
            return (options.find((option) => typeof option.value === 'string'
                ? option.value === value
                : Array.isArray(option.options)
                    ? this.isValueInOptions(value, option.options)
                    : false) !== undefined);
        };
        this.filterValuesInOptions = (values, options) => {
            return values.filter((value) => this.isValueInOptions(value, options) !== undefined);
        };
        this.afterPatchOptions = (value, _state, _component, key) => {
            if (key === '_value') {
                this.setFormAssociatedValue(value);
            }
        };
        this.beforePatchOptions = (_value, nextState) => {
            const raw = nextState.get('_value');
            if (raw !== undefined && !Array.isArray(raw)) {
                nextState.set('_value', [raw]);
            }
            const options = nextState.has('_options') ? nextState.get('_options') : this.component.state._options;
            if (Array.isArray(options) && options.length > 0) {
                this.keyOptionMap.clear();
                fillKeyOptionMap(this.keyOptionMap, options);
                const value = nextState.has('_value') ? nextState.get('_value') : this.component.state._value;
                const selected = this.filterValuesInOptions(Array.isArray(value) && value.length > 0 ? value : [], options);
                if (this.component._multiple === false && selected.length === 0) {
                    nextState.set('_value', [
                        options[0].value,
                    ]);
                }
                else if (Array.isArray(value) && selected.length < value.length) {
                    nextState.set('_value', selected);
                }
            }
        };
        this.component = component;
    }
    validateOptions(value) {
        validateOptionsWithOptgroup(this.component, value, {
            hooks: {
                afterPatch: this.afterPatchOptions,
                beforePatch: this.beforePatchOptions,
            },
        });
    }
    validateMultiple(value) {
        this.assertComponentValueMatchesMultiplicity(value === true);
        validateMultiple(this.component, value, {
            hooks: {
                afterPatch: this.afterPatchOptions,
                beforePatch: this.beforePatchOptions,
            },
        });
    }
    validateRequired(value) {
        validateRequired(this.component, value);
    }
    validateRows(value) {
        validateRows(this.component, value);
    }
    validateValue(value) {
        this.assertValueMatchesMultiplicity(value);
        watchJsonArrayString(this.component, '_value', () => true, value === undefined ? [] : Array.isArray(value) ? value : [value], undefined, {
            hooks: {
                afterPatch: this.afterPatchOptions,
                beforePatch: this.beforePatchOptions,
            },
        });
    }
    componentWillLoad() {
        super.componentWillLoad();
        this.validateOptions(this.component._options);
        this.validateMultiple(this.component._multiple);
        this.validateRequired(this.component._required);
        this.validateRows(this.component._rows);
        this.validateValue(this.component._value);
    }
    assertValueMatchesMultiplicity(value) {
        const isArray = Array.isArray(value);
        const isMultiple = this.component._multiple === true;
        if (isMultiple) {
            if (value !== undefined && !isArray) {
                throw new Error(`↑ The schema for the property (_value) is not valid for multiple mode. Expected an array. The value will not be changed. (received = ${JSON.stringify(value)})`);
            }
        }
        else {
            if (isArray) {
                throw new Error(`↑ The schema for the property (_value) is not valid for single mode. Expected a single value. The value will not be changed. (received = ${JSON.stringify(value)})`);
            }
        }
    }
    assertComponentValueMatchesMultiplicity(isMultiple) {
        const rawValue = this.component._value;
        if (isMultiple) {
            if (rawValue !== undefined && !Array.isArray(rawValue)) {
                throw new Error(`↑ The schema for the property (_value) is not valid for multiple mode. Expected an array. The value will not be changed. (current = ${JSON.stringify(rawValue)})`);
            }
        }
        else {
            if (Array.isArray(rawValue)) {
                throw new Error(`↑ The schema for the property (_value) is not valid for single mode. Expected a single value. The value will not be changed. (current = ${JSON.stringify(rawValue)})`);
            }
        }
    }
}

const KolSelectWc = class {
    async getValue() {
        if (this._multiple) {
            return this.state._value;
        }
        else {
            return Array.isArray(this.state._value) && this.state._value.length > 0 ? this.state._value[0] : this.state._value;
        }
    }
    async focus(options) { }
    async click() { }
    getFormFieldProps() {
        return {
            state: this.state,
            class: clsx('kol-form-field-select', {
                'kol-form-field--has-value': this.state._hasValue,
            }),
            tooltipAlign: this._tooltipAlign,
            onClick: () => { var _a; return (_a = this.ctaRef.el) === null || _a === void 0 ? void 0 : _a.focus(); },
            alert: this.showAsAlert(),
            infoPopover: this._infoPopover,
        };
    }
    getSelectProps() {
        return Object.assign(Object.assign({ ref: this.ctaRef, state: this.state }, this.controller.onFacade), { onInput: this.onInput.bind(this), onChange: this.onChange.bind(this), onFocus: (event) => {
                this.controller.onFacade.onFocus(event);
                this.inputHasFocus = true;
            }, onBlur: (event) => {
                this.controller.onFacade.onBlur(event);
                this.inputHasFocus = false;
            } });
    }
    render() {
        return (h(FormFieldStateWrapper, Object.assign({ key: 'dade530dd86e45be9891810c39bd09755ffc2fc2' }, this.getFormFieldProps()), h(InputContainerStateWrapperFc, { key: 'bc801552e63781dc6b4d15f07fc994776d740d6a', state: this.state }, h("form", { key: '49e75773b97ff146360efd9b77b81a25a789449b', onSubmit: (event) => {
                event.preventDefault();
                propagateSubmitEventToForm({
                    form: this.host});
            } }, h("input", { key: 'afbe2b214db72607bbb87291f30dd0c4bf336397', type: "submit", hidden: true }), h(SelectStateWrapper, Object.assign({ key: '752c1968182844215e0d0d8b0eed6401a3808c8d' }, this.getSelectProps()))))));
    }
    validateAriaDetails(value) {
        this.controller.validateAriaDetails(value);
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.ctaRef = createCtaRef();
        this._disabled = false;
        this._hideMsg = false;
        this._hideLabel = false;
        this._hint = '';
        this._multiple = false;
        this._required = false;
        this._tooltipAlign = 'top';
        this._touched = false;
        this.state = {
            _hasValue: false,
            _hideMsg: false,
            _id: createUniqueId('select'),
            _label: '',
            _multiple: false,
            _options: [],
            _value: [],
        };
        this.inputHasFocus = false;
        this.controller = new SelectController(this, 'select', this.host);
    }
    showAsAlert() {
        return Boolean(this.state._touched) && !this.inputHasFocus;
    }
    validateAccessKey(value) {
        this.controller.validateAccessKey(value);
    }
    validateDisabled(value) {
        this.controller.validateDisabled(value);
    }
    validateHideMsg(value) {
        this.controller.validateHideMsg(value);
    }
    validateHideLabel(value) {
        this.controller.validateHideLabel(value);
    }
    validateHint(value) {
        this.controller.validateHint(value);
    }
    validateIcons(value) {
        this.controller.validateIcons(value);
    }
    validateLabel(value) {
        this.controller.validateLabel(value);
    }
    validateMsg(value) {
        this.controller.validateMsg(value);
    }
    validateMultiple(value) {
        this.controller.validateMultiple(value);
    }
    validateName(value) {
        this.controller.validateName(value);
    }
    validateOn(value) {
        this.controller.validateOn(value);
    }
    validateOptions(value) {
        this.controller.validateOptions(value);
    }
    validateRequired(value) {
        this.controller.validateRequired(value);
    }
    validateRows(value) {
        this.controller.validateRows(value);
    }
    validateShortKey(value) {
        this.controller.validateShortKey(value);
    }
    validateSyncValueBySelector(value) {
        this.controller.validateSyncValueBySelector(value);
    }
    validateTabIndex(value) {
        this.controller.validateTabIndex(value);
    }
    validateTouched(value) {
        this.controller.validateTouched(value);
    }
    validateValue(value) {
        this.controller.validateValue(value);
    }
    validateVariant(value) {
        this.controller.validateVariant(value);
    }
    componentWillLoad() {
        this.validateAriaDetails(this._ariaDetails);
        this._touched = this._touched === true;
        this.controller.componentWillLoad();
        this.state._hasValue = !!this.state._value;
        this.controller.addValueChangeListener((v) => (this.state._hasValue = !!v));
    }
    onInput(event) {
        var _a;
        const selectedValues = Array.from(((_a = this.ctaRef.el) === null || _a === void 0 ? void 0 : _a.options) || [])
            .filter((option) => option.selected)
            .map((option) => { var _a; return (_a = this.controller.getOptionByKey(option.value)) === null || _a === void 0 ? void 0 : _a.value; });
        if (this._multiple) {
            this._value = selectedValues;
            this.controller.onFacade.onInput(event, true, selectedValues);
        }
        else {
            const singleValue = selectedValues.length > 0 ? selectedValues[0] : undefined;
            this._value = singleValue;
            this.controller.onFacade.onInput(event, true, singleValue);
        }
    }
    onChange(event) {
        if (this._multiple) {
            this.controller.onFacade.onChange(event, this._value);
        }
        else {
            this.controller.onFacade.onChange(event, this._value);
        }
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_ariaDetails": ["validateAriaDetails"],
        "_accessKey": ["validateAccessKey"],
        "_disabled": ["validateDisabled"],
        "_hideMsg": ["validateHideMsg"],
        "_hideLabel": ["validateHideLabel"],
        "_hint": ["validateHint"],
        "_icons": ["validateIcons"],
        "_label": ["validateLabel"],
        "_msg": ["validateMsg"],
        "_multiple": ["validateMultiple"],
        "_name": ["validateName"],
        "_on": ["validateOn"],
        "_options": ["validateOptions"],
        "_required": ["validateRequired"],
        "_rows": ["validateRows"],
        "_shortKey": ["validateShortKey"],
        "_syncValueBySelector": ["validateSyncValueBySelector"],
        "_tabIndex": ["validateTabIndex"],
        "_touched": ["validateTouched"],
        "_value": ["validateValue"],
        "_variant": ["validateVariant"]
    }; }
};
__decorate([
    directFocus('ctaRef')
], KolSelectWc.prototype, "focus", null);
__decorate([
    directClick('ctaRef')
], KolSelectWc.prototype, "click", null);

export { KolSelectWc as kol_select_wc };
//# sourceMappingURL=kol-select-wc.entry.js.map
